/**
 * Tournament picks copy (specs/champions-league, Story 2).
 *
 * Stage wording, not matchweek wording. Kept beside the screen rather than in
 * SeasonPicks.constants so retuning one format's copy can never silently retune the other.
 */

export const TOURNAMENT_PICKS_EMPTY_TITLE = 'No fixtures yet';
const TOURNAMENT_PICKS_EMPTY_SUBTITLE = 'Rounds appear here as the draw is made.';
const TOURNAMENT_PICKS_PREV_STAGE = 'Previous round';
const TOURNAMENT_PICKS_NEXT_STAGE = 'Next round';
export const TOURNAMENT_PICKS_FALLBACK_TITLE = 'Tournament picks';

export const TOURNAMENT_PICKS_COPY = {
  emptyTitle: TOURNAMENT_PICKS_EMPTY_TITLE,
  emptySubtitle: TOURNAMENT_PICKS_EMPTY_SUBTITLE,
  prevLabel: TOURNAMENT_PICKS_PREV_STAGE,
  nextLabel: TOURNAMENT_PICKS_NEXT_STAGE,
} as const;
